import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromGraphql from "./citizen-verify-phone-number.graphql";
import * as fromActions from "./citizen-verify-phone-number.actions"
import {map, switchMap} from 'rxjs';


@Injectable()
export class CitizenVerifyPhoneNumberEffects {


  citizenVerifyPhoneNumber = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenVerifyPhoneNumber),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CITIZEN_VERIFY_PHONE_NUMBER,
        variables: {
          userPhoneNumber: action?.userPhoneNumber
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              // this.store.dispatch(
              //   fromActions.upsertCitizenVerifyPhoneNumber({ citizenVerifyPhoneNumber: result?.data })
              // );
              this.notificationService.successMessage('Phone Number Successfully  Verified');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
